import { useEffect, useState } from 'react';
import loadingGif from '../../assets/LoadingSkillChallenge.gif';
import { motion } from 'motion/react';
interface Props {
  onFinish: () => void;
}

const TEXTS: { [key: number]: string } = {
  0: 'Switching to skill challenge mode!',
  1: 'Show what you know.',
  2: 'Do your best!',
};

const STEP_DURATION = 2500;

export const PreSkillChallenge = ({ onFinish }: Props) => {
  const [animationStep, setAnimationStep] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setAnimationStep(prev => {
        if (prev >= 3) {
          clearInterval(intervalId);
          return 4;
        }
        return prev + 1;
      });
    }, STEP_DURATION);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const totalDuration = 3 * STEP_DURATION;
    const timer = setTimeout(() => {
      onFinish();
    }, totalDuration);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ duration: 0.5, delay: 6 }}
      style={{
        visibility: animationStep < 3 ? 'visible' : 'hidden',
        // A full-screen takeover, so it tracks the viewport via `fixed` + inset rather than
        // `absolute` + an explicit height. `height: 200vh` stacked a second viewport of dead
        // scrollable background on top of the one the skill-challenge wrapper already had, and
        // `absolute` anchored it to whichever ancestor happened to be positioned — which the
        // skill-challenge wrapper no longer is. The app header (z-index 4) still paints above.
        position: 'fixed',
        inset: 0,
        zIndex: 3,
      }}
      className="tw-bg-neutral-100"
    >
      <div className="tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center">
        <div>
          <div className="tw-flex tw-justify-center tw-w-full tw-items-center">
            {animationStep < 3 && <img src={loadingGif} style={{ width: '10rem', height: '10rem' }} />}
          </div>
          <motion.h3
            key={animationStep}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 0.5,
            }}
            className="tw-w-full tw-text-center tw-mt-3"
          >
            {TEXTS[animationStep]}
          </motion.h3>
        </div>
      </div>
    </motion.div>
  );
};
